module.exports = __webpack_public_path__ + "assets/img/cytonn-photography-GJao3ZTX9gU-unsplash.d569b81b.jpg";